import { t } from "@/utils/localization/i18n"

export function handleServiceError(errorMessage,vm = null) {
  const found = API_ERROR.get(errorMessage);
  const message = found ? found.message : "errorMessage.plsTryAgain";
  const type = found?.type || 'error'; 
  if (vm && vm.$toast) {
    vm.$toast[type](t(message));
  } 
}
export function handleError(commit, action,error, isThrowError = true) {
  const message = error.response?.data?.message || error.message || `${action} Failed`;
  commit("SET_ERROR", { action, message });
  if (isThrowError) {
    throw error;
  }
}

export const API_ERROR = new Map([

  // ----------------- RESERVE ERRORS -----------------
  ["Reserve Fail, Product seat already exist", { message: "course.alreadyReserve", type: "warning" }],
  ["Course is not in reserve period", { message: "errorMessage.invalidReserveDate", type: "warning" }],
  ["Reserve product already exist", { message: "course.alreadyReserve", type: "warning" }],
  
   // ----------------- EXPORT ERRORS -----------------
  ["Data not found", { message: "errorMessage.noExportData", type: "warning" }],


]);